import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
const DefaultContainer = () => import('@/containers/DefaultContainer.vue');
const NotFound = () => import('@/views/NotFound.vue');

import Welcome from '../views/Welcome.vue'

Vue.use(VueRouter)

const routes: RouteConfig[] = [
  {
    path: '/',
    redirect: '/welcome',
    component: DefaultContainer,
    children: [
      {
        path: '',
        name: 'Home',
        redirect: '/welcome'
      },
      {
        path: 'welcome',
        name: 'welcome',
        component: Welcome
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Login.vue')
      },
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Login.vue')
      },
      {
        path: 'signout',
        name: 'signout',
        component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Logout.vue')
      },
      {
        path: 'about',
        name: 'about',
        component: () => import(/* webpackChunkName: "meta" */ '../views/public/About.vue')
      },
      {
        path: 'accessibility',
        name: 'accessibility',
        component: () => import(/* webpackChunkName: "meta" */ '../views/public/Accessibility.vue')
      },
      {
        path: 'cookies',
        name: 'cookies',
        component: () => import(/* webpackChunkName: "meta" */ '../views/public/Cookies.vue')
      },
      {
        path: 'faq',
        name: 'faq',
        component: () => import(/* webpackChunkName: "meta" */ '../views/public/FAQs.vue')
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: () => import(/* webpackChunkName: "meta" */ '../views/public/Privacy.vue')
      },
      {
        path: 'terms',
        name: 'terms',
        component: () => import(/* webpackChunkName: "meta" */ '../views/public/Terms.vue')
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import(/* webpackChunkName: "contact" */ '../views/public/ContactUs.vue')
      },
      {
        path: 'contact/moderator',
        name: 'contact-moderator',
        component: () => import(/* webpackChunkName: "contact" */ '../views/messages/MessageModerator.vue')
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/Profile.vue'),
        meta: {
          authorized_users: ["loggedinuser"]
        }
      },
      {
        path: 'need/support',
        name: 'request-support',
        component: () => import(/* webpackChunkName: "aram_base" */ '../views/help/RequestSupport.vue')
      },
      {
        path: 'can/support',
        name: 'offer-support',
        component: () => import(/* webpackChunkName: "aram_base" */ '../views/volunteering/OfferSupport.vue')
      },
      {
        path: `volunteer-registration-confirmation`,
        name: `volunteer-registration-confirmation`,
        component: () => import(/* webpackChunkName: "aram_base" */ '../views/public/VolunteerRegisterConfirmation.vue')
      },
      {
        path: 'support-requests',
        name: 'support-requests',
        redirect: '/support-requests/bystatus/new',
        meta: {
          authorized_users: ["verifiedvolunteer","moderator","admin"]
        }
      },
      {
        path: 'support-requests/bystatus/:status',
        name: 'support-requests-bystatus',
        component: () => import(/* webpackChunkName: "support" */ '../views/help/SupportRequests.vue'),
        meta: {
          authorized_users: ["verifiedvolunteer","moderator","admin"]
        }
      },
      {
        path: 'support-request/:supportrequestid',
        name: 'supportrequest',
        component: () => import(/* webpackChunkName: "support" */ '../views/help/SupportRequest.vue'),
        meta: {
          authorized_users: ["verifiedvolunteer","moderator","admin"]
        }
      },
      {
        path: 'track',
        name: 'track-request',
        component: () => import(/* webpackChunkName: "track" */ '../views/help/TrackRequest.vue')
      },
      {
        path: 'volunteers',
        name: 'volunteers',
        component: () => import(/* webpackChunkName: "volunteers" */ '../views/volunteering/VolunteersList.vue'),
        meta: {
          authorized_users: ["moderator","admin"]
        }
      },      
      {
        path: 'volunteer/:volunteeruid',
        name: 'volunteer',
        component: () => import(/* webpackChunkName: "volunteers" */ '../views/volunteering/Volunteer.vue'),
        meta: {
          authorized_users: ["loggedinuser"]
        }
      },
      {
        path: 'groups',
        name: 'groups',
        component: () => import(/* webpackChunkName: "groups" */ '../views/groups/Groups.vue'),
        meta: {
          authorized_users: ["moderator","admin"]
        }
      },
      {
        path: 'group_members',
        name: 'group_members',
        component: () => import(/* webpackChunkName: "groups" */ '../views/groups/GroupMembers.vue'),
        meta: {
          authorized_users: ["moderator","admin"]
        }
      },
      {
        path: 'groups/hierarchy',
        name: 'groups-hierarchy',
        component: () => import(/* webpackChunkName: "groups" */ '../views/groups/GroupsHierarchy.vue'),
        meta: {
          authorized_users: ["moderator","admin"]
        }
      },
      {
        path: 'group/:groupid',
        name: 'group',
        component: () => import(/* webpackChunkName: "groups" */ '../views/groups/Group.vue'),
        meta: {
          authorized_users: ["moderator","admin"]
        }
      },
      {
        path: 'groups/create',
        name: 'groups-create',
        component: () => import(/* webpackChunkName: "groups" */ '../views/groups/Create.vue'),
        meta: {
          authorized_users: ["moderator","admin"]
        }
      },
      {
        path: 'donations',
        name: 'donations',
        redirect: '/donations/bystatus/new'        
      },      
      {
        path: 'donations/bystatus/:status',
        name: 'donations-bystatus',
        component: () => import(/* webpackChunkName: "donate" */ '../views/donations/Donations.vue'),
        meta: {
          authorized_users: ["moderator","admin"]
        }
      },      
      {
        path: 'donation/:donationid',
        name: 'donation',
        component: () => import(/* webpackChunkName: "donate" */ '../views/donations/Donation.vue'),
        meta: {
          authorized_users: ["verifiedvolunteer","moderator","admin"]
        }
      },
      {
        path: 'donate',
        name: 'donate',
        component: () => import(/* webpackChunkName: "aram_base" */ '../views/donations/Donate.vue')
      },
      {
        path: 'moderator-dashboard',
        name: 'moderator-dashboard',
        redirect: '/moderator-dashboard/default',
        meta: {
          authorized_users: ["admin","moderator"]
        }        
      },
      {
        path: 'moderator-dashboard/:page_mode',
        name: 'moderator-detailed-dashboard',
        component: () => import(/* webpackChunkName: "admin" */ '../views/moderator/Moderator.vue'),
        meta: {
          authorized_users: ["admin","moderator"]
        }
      },
      {
        path: 'moderator',
        name: 'moderator',
        component: () => import(/* webpackChunkName: "admin" */ '../views/moderator/Moderator.vue'),
        meta: {
          authorized_users: ["admin","moderator"]
        }
      },
      {
        path: 'admin',
        name: 'admin',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/Admin.vue')
      },
      {
        path: 'admin/appsettings',
        name: 'admin-appsettings',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/AppSettings.vue'),
        meta: {
          authorized_users: ["admin"]
        }
      },
      {
        path: 'admin/emailsettings',
        name: 'admin-emailsettings',
        component: () => import(/* webpackChunkName: "admin" */ '../views/admin/EmailSettings.vue'),
        meta: {
          authorized_users: ["admin"]
        }
      },
      {
        path: 'admin/messages',
        name: 'messageslist',
        component: () => import(/* webpackChunkName: "admin" */ '../views/messages/Messages.vue'),
        meta: {
          authorized_users: ["admin","moderator"]
        }
      },
      {
        path: 'cognizant-assist',
        name: 'cognizant-assist',
        component: () => import(/* webpackChunkName: "cognizant-assist" */ '../views/public/Cognizant-Assist.vue'),
      },
      {
        path: 'sorry',
        name: 'sorry',
        component: NotFound
      },
      { 
        path: '*', 
        redirect: '/sorry' 
      }    
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
